const employRoutes = [
  {
    path: "/employ",
    name: "",
    meta: {
      title: "취업정보",
      isDynamic: true,
    },
    children: [
      {
        path: "rcmt", // /employ/rcmt
        name: "studentEmployRcrt",
        meta: {
          title: "교내채용",
          menuCd: "STUDENT_RCMT",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/StudentEmployRcrt.vue"),
      },
      {
        path: "rcmt/:id", // /employ/rcmt/:id
        name: "studentEmployRcrtDetail",
        meta: {
          title: "교내채용 상세",
          menuCd: "STUDENT_RCMT",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/StudentEmployRcrtDetail.vue"),
      },
      {
        path: "career", // /employ/career
        name: "studentEmployCareer",
        meta: {
          title: "교내채용",
          menuCd: "STUDENT_CAREER",
          isDynamic: true,
        },
        component: () => import("@/views/student/student-employ/StudentCareerSearch.vue"),
      },
      {
        path: "spec", // /employ/spec
        name: "studentEmploySpec",
        meta: {
          title: "취업스펙",
          menuCd: "STUDENT_SPEC",
          isDynamic: true,
        },
        component: () => import("@/views/student/student-employ/StudentEmploySpec.vue"),
      },
      {
        path: "starter", // /employ/starter
        name: "studentEmployStarter",
        meta: {
          title: "스타터채용",
          menuCd: "STUDENT_RCMT_STARTER",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/externalRcrt/StudentEmployStarter.vue"),
      },
      {
        path: "qnet", // /employ/qnet
        name: "studentEmployQnet",
        meta: {
          title: "Q-net 자격정보",
          menuCd: "STUDENT_RCMT_QNET",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/q-net/StudentQnetLicenseIndex.vue"),
      },
      {
        path: "qnet/detail", // /employ/qnet/detail
        name: "studentEmployQnetDetail",
        meta: {
          title: "Q-net 자격정보 상세",
          menuCd: "STUDENT_RCMT_QNET",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/q-net/StudentQnetLicenseDetail.vue"),
      },
      {
        path: "wrk",
        name: "studentEmployWrkJobIndex",
        meta: {
          title: "고용24 직업정보",
          menuCd: "STUDENT_RCMT_WRK",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/work24/StudentEmployWrkJobIndex.vue"),
      },
      {
        path: "wrk/duty",
        name: "studentEmployWrkDuty",
        meta: {
          title: "고용24 직무정보",
          menuCd: "STUDENT_RCMT_WRK",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/work24/StudentEmployWrkDuty.vue"),
      },
    ],
  },
];
export default employRoutes;
